import { React } from "react";
import { Navigate } from 'react-router-dom'
import ProjectNav from "./ProjectNav";

//MUI Imports 

import Box from '@mui/material/Box';

function ProjectPage({ children, pageMeta, pageMetas, projectData, schema, shouldRenderPage }) {

  let assmentFieldsCompleteCount = projectData.entries.assessmentID ? Object.keys(projectData.entries.assessmentID).length : 0
  let urlBase = `${process.env.PUBLIC_URL}/project/${projectData.projectId}/`
  
  switch (pageMeta.slug) {
    case pageMetas.home.slug:

      //Lets check if the project has some data,  if so,  we skip the welcome screen
      if(projectData.entries.assessmentID){

        if(assmentFieldsCompleteCount > 0 && assmentFieldsCompleteCount !== schema.entryOptions.screen.assessmentID.fields.length){
          return(
            <Navigate to={`${urlBase}${pageMetas.assessmentId.slug}`}/>
          )
        }else if(assmentFieldsCompleteCount === schema.entryOptions.screen.assessmentID.fields.length){
          return(
            <Navigate to={`${urlBase}${pageMetas.screening.slug}`}/>
          )
        }

        return(
          <Navigate to={`${urlBase}${pageMetas.welcome.slug}`}/>
        )
      }
      /* falls through */
    default:

      return (
        <Box className="content_wrapper content_wrapper__white">
          <ProjectNav project={projectData}/>
          {children}
        </Box>
      );

  }
}

export default ProjectPage